export default "__VITE_ASSET__zSAi5zTM__"